import { render, staticRenderFns } from "./tbqr.vue?vue&type=template&id=58675e50&"
import script from "./tbqr.vue?vue&type=script&lang=js&"
export * from "./tbqr.vue?vue&type=script&lang=js&"
import style0 from "./tbqr.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports